module.exports = __webpack_public_path__ + "website/img/elephant-q.0dc9b473.svg";